import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Typography,
  Stack,
  Box,
  Avatar
} from "@mui/material";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';

export const ProjectInfoDialog = ({ open, handleClose, ownerData, projectData }) => {
  const handleDialogClose = (event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      handleClose();
    }
  };

  const paperProps = {
    sx: {
      borderRadius: 3,
      overflow: 'hidden',
      boxShadow: '0px 12px 40px rgba(15, 23, 42, 0.18)'
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      fullWidth
      maxWidth="sm"
      PaperProps={paperProps}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2.5,
          pr: 2,
          pl: 3
        }}
      >
        <Box>
          <Typography variant="h5" component="div">
          {projectData?.name || 'Unnamed Project'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Project name
          </Typography>
        </Box>
        <IconButton
          aria-label="Close project info dialog"
          onClick={handleClose}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent
        dividers
        sx={{
          px: { xs: 2.5, sm: 3 },
          py: { xs: 2.5, sm: 3 },
          bgcolor: 'background.default'
        }}
      >
        <Stack spacing={3}>

          {/* Project Information Section */}
          <Box>
            {/* <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
              Project Details
            </Typography> */}
            <Stack spacing={2}>
              <Box>
                {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Project Name
                </Typography> */}
                <Typography variant="subtitle2" component="div">
                  Details
                </Typography>
              </Box>
              <Box>
                {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Description
                </Typography> */}
                {projectData?.description ? (
                  <Typography variant="body1" color="text.primary">
                    {projectData.description}
                  </Typography>
                ) : (
                  <Typography variant="body1" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    No description available
                  </Typography>
                )}
              </Box>
            </Stack>
          </Box>

          

          <Divider />
{/* Owner Information Section */}
<Box>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <Avatar
                alt={ownerData?.name || 'Owner'}
                src={ownerData?.picurl || ''}
                sx={{
                  width: 48,
                  height: 48,
                  border: '2px solid',
                  borderColor: 'divider'
                }}
              />
              <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle2" component="div" sx={{ mb: 0.5 }}>
                  {ownerData?.name || 'Unknown Owner'}
                </Typography>
                {ownerData?.bio && (
                  <Typography variant="body2" color="text.secondary">
                    {ownerData.bio}
                  </Typography>
                )}
                {!ownerData?.bio && (
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    No bio available
                  </Typography>
                )}
              </Box>
            </Stack>
          </Box>
          
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions
        sx={{
          px: { xs: 2.5, sm: 3 },
          py: { xs: 2.5, sm: 3 },
          bgcolor: 'background.paper',
          justifyContent: 'flex-end',
          gap: 1.5
        }}
      >
        <Button
          onClick={handleClose}
          variant="outlined"
          color="inherit"
          startIcon={<CloseIcon fontSize="small" />}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

